import './bluefiretotalhillside/style';
import FormStructure from './bluefiretotalhillside/form_structure';

export default FormStructure;